import Vue from 'vue'
import VueRouter from 'vue-router'
import { canNavigate } from '@/plugins/acl/routeProtection'
import app from './system/app'
import dashboard from './system/dashboard'
import config from './system/config'

// Custom
import custom from './custom'

Vue.use(VueRouter)

const routes = [
  ...app,
  ...dashboard,

  // Custom
  ...custom,

  // Others
  ...config,
  {
    path: '*',
    redirect: 'error-404',
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

// ? Router Before Each hook: https://router.vuejs.org/guide/advanced/navigation-guards.html
router.beforeEach((to, _, next) => {
  const userData = JSON.parse(localStorage.getItem('userData'))

  const isLoggedIn = userData && localStorage.getItem('accessToken')

  if (!canNavigate(to) || (to.name === 'config-users' && (userData === null || userData.role !== 'admin'))) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login', query: { marketplace: to.query.marketplace } })

    // If logged in => not authorized
    return next({ name: 'error-404' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    next('/')
  }

  return next()
})

export default router
